.trigger {
    align-items: center;
    background: var(--color-bleached-silk);
    border-bottom: 1px solid var(--color-kingly-cloud);
    border-top: 1px solid var(--color-kingly-cloud);
    color: var(--color-crimson);
    display: flex;
    gap: 8px;
    justify-content: center;
    padding: 0.5em 0;
    text-align: center;
    width: 100%;
}

.pinIcon {
    height: 22px;
    width: 17px;
}

.caretIcon {
    height: 19px;
    width: 14px;

    & svg {
        fill: var(--color-crimson);
    }
}
